"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "belmonte-del-sannio": {
    "roccalabate": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25180f2a": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "santa-barbara": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6faf1de3": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-la-noce": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a53fe985": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "selvotte": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "93d9287e": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "serra-carpini": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "593c3405": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "serra-san-martino": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "61632e67": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "sotto-gli-orti": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea6b8530": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "vicenne": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fcb7b3b5": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "carcamo": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "23578d12": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "castellana": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "02b4ebd0": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "colle-di-maggio": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "94a056cb": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "colle-sant-angelo": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9d13328e": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-canale": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a804e567": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "difesa": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d2d3d2d9": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "difesa-cordari": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c3930a6d": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "padule-piane": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8e537b6a": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }],
    "portelle": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "883c9f6d": [{
      "hkey": "68c982cb",
      "slug": "belmonte-del-sannio",
      "name": "Belmonte del Sannio",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;